import { defineStore } from 'pinia';
import { ref } from 'vue';
import Client from '@/repositories/clients/AuthenticatedClient';
import { useTokenBalanceStore } from '@/stores/useTokenBalanceStore';

export const useShadowHistoryQuoteStore = defineStore('shadowHistoryQuote', () => {
  const quote = ref(null);
  let settle = null;
  let pending = false;

  async function confirm(startDate, endDate) {
    if (pending) throw new Error('A historical simulation confirmation is already open.');
    pending = true;
    try {
      const { data } = await Client.post('/tools/shadow-trading/history-quote', {
        start_date: startDate, end_date: endDate,
      });
      if (!Number.isSafeInteger(data.tokens) || data.tokens < 1 || !Number.isSafeInteger(data.rate_version)) {
        throw new Error('Invalid historical simulation quote.');
      }
      await useTokenBalanceStore().refresh({ force: true });
      quote.value = { ...data, start_date: startDate, end_date: endDate };
      return await new Promise(resolve => { settle = resolve; });
    } finally { pending = false; }
  }

  function choose(accepted) {
    const resolve = settle;
    const result = accepted && useTokenBalanceStore().totalBalance >= quote.value?.tokens ? quote.value : null;
    settle = null;
    quote.value = null;
    resolve?.(result);
  }

  return { quote, confirm, choose };
});
